import useGameState, { ONBOARDING_PHASE } from "app/game/useGameState";
import { useCallback, useState } from "react";
import NewPlayerPanel from "./NewPlayerPanel";
import { type TutorialLevel } from "./tutorial-data";
import TUTORIAL_LEVEL_ORDER from "./tutorial-level-order";
import TutorialProgressPanel from "./TutorialProgressPanel";
import TutorialSkipConfirm from "./TutorialSkipConfirm";
import useTutorialState from "./useTutorialState";

interface OnboardingOverlaysProps {
  onTutorialLevelStarted: (level: TutorialLevel) => void;
  onTutorialFinished: () => void;
}

// Manages the overlays related to new player onboarding. Shows different
// panels depending on their progress through the FTUE.
export default function OnboardingOverlays({
  onTutorialLevelStarted,
  onTutorialFinished,
}: OnboardingOverlaysProps) {
  const [showSkipPanel, setShowSkipPanel] = useState(false);
  const { onboardingPhase } = useGameState();
  const { isInTutorial } = useTutorialState();

  const onNewPlayerPanelStart = useCallback(() => {
    onTutorialLevelStarted(TUTORIAL_LEVEL_ORDER[0]);
  }, [onTutorialLevelStarted]);

  if (isInTutorial) {
    return <></>;
  }

  if (showSkipPanel) {
    return (
      <TutorialSkipConfirm
        onBackOut={() => setShowSkipPanel(false)}
        onConfirm={() => onTutorialFinished()}
      />
    );
  }

  if (onboardingPhase === ONBOARDING_PHASE.NEW_PLAYER) {
    return (
      <NewPlayerPanel
        onStartTutorial={onNewPlayerPanelStart}
        onSkipTutorial={() => setShowSkipPanel(true)}
      />
    );
  } else if (onboardingPhase === ONBOARDING_PHASE.STARTED) {
    return (
      <TutorialProgressPanel
        onLevelStarted={() => {}}
        onSkip={() => setShowSkipPanel(true)}
        onAllFinished={() => onTutorialFinished()}
      />
    );
  }
}
